export default __webpack_public_path__ + "static/media/senior-sample10.a929c266.png";